var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-text-gray-600"},[_c('svg-icon',{staticClass:"tw-block tw-rounded tw-mr-1 notification-icon",attrs:{"name":"time"}}),_c('span',{staticClass:"tw-mr-1 tw-text-sm tw-font-semibold",domProps:{"textContent":_vm._s(_vm.time)}}),_c('span',{staticClass:"tw-text-xs"},[_vm._v(_vm._s(_vm.suffix))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }